import xhr from 'xhr.js';
import auth from 'services/auth';

const integrations = {
    createZoomToken: async code => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/zoom/token?account_id=${account_id}`,
            {},
            {
                withCredentials: true,
                params: {
                    code
                }
            }
        );
        return res.data;
    },
    disconnectZoomAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/zoom/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectZoomUser: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/zoom/disconnectUser?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectCalendlyAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/calendly/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectTremendousAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/tremendous/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    getSalesforceAuthRedirectUrl: async domain => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(
            `/integrations/salesforce/authorize-redirect?account_id=${account_id}&domain=${domain}`,
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    disconnectSalesforceAccount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/salesforce/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    getSalesforceProperties: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/integrations/salesforce/contact-properties?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    /**
     * Map Salesforce properties to Private Panels properties
     *
     * @param {Object} body
     * @param {Object} body.map The mapping of Salesforce properties to Private Panels properties
     * @param {Object} params
     * @param {string} params.panelId The panel ID
     * @param {string} params.salesforceListviewId The Salesforce listview ID
     */
    mapSalesforceToPanelfox: async ({ map }, { panelId, salesforceListviewId }) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/salesforce/map-properties`,
            {
                map
            },
            {
                withCredentials: true,
                params: {
                    account_id,
                    salesforce_listview_id: salesforceListviewId,
                    panel_id: panelId
                }
            }
        );
        return res.data;
    },
    runSalesforceSync: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/integrations/salesforce/run?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    /**
     * Get Salesforce listviews
     */
    getSaleforceListviews: async () => {
        const accountId = auth.getAccountId();
        const res = await xhr.get('/integrations/salesforce/listviews', {
            withCredentials: true,
            params: {
                account_id: accountId
            }
        });
        return res.data;
    },
    /**
     * Get Salesforce integration info
     */
    getSaleforceIntegrationInfo: async () => {
        const accountId = auth.getAccountId();
        const res = await xhr.get('/integrations/salesforce/info', {
            withCredentials: true,
            params: {
                account_id: accountId
            }
        });
        return res.data;
    },
    /**
     * Connect Qualtrics account
     */
    connectQualtrics: async (
        qualtricsApiToken,
        qualtricsDatacenterId,
        qualtricsOrganizationId,
        qualtricsUiDatacenterId
    ) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/qualtrics/connect`,
            {},
            {
                withCredentials: true,
                params: {
                    account_id,
                    qualtrics_api_token: qualtricsApiToken,
                    qualtrics_datacenter_id: qualtricsDatacenterId,
                    qualtrics_organization_id: qualtricsOrganizationId,
                    qualtrics_ui_datacenter_id: qualtricsUiDatacenterId
                }
            }
        );
        return res.data;
    },
    /**
     * Update Qualtrics account
     */
    updateQualtrics: async (qualtricsDatacenterId, qualtricsOrganizationId, qualtricsUiDatacenterId) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/qualtrics/update`,
            {},
            {
                withCredentials: true,
                params: {
                    account_id,
                    qualtrics_datacenter_id: qualtricsDatacenterId,
                    qualtrics_organization_id: qualtricsOrganizationId,
                    qualtrics_ui_datacenter_id: qualtricsUiDatacenterId
                }
            }
        );
        return res.data;
    },
    /**
     * Disconnect Qualtrics account
     */
    disconnectQualtrics: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/integrations/qualtrics/disconnect?account_id=${account_id}`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    /**
     * Get Qualtrics surveys
     */
    getQualtricsSurveys: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/integrations/qualtrics/surveys?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    }
};

export default integrations;
